import {RootState} from 'types';

export const getAssetPairs = (state: RootState) => state.assetPairs;
export const getAuthentication = (state: RootState) => state.authentication;
export const getComments = (state: RootState) => state.comments;
export const getConnectFiveActiveMatches = (state: RootState) => state.connectFive.activeMatches;
export const getConnectFiveChallengesById = (state: RootState) => state.connectFive.challengesById;
export const getConnectFiveCompletedMatches = (state: RootState) => state.connectFive.completedMatches;
export const getConnectFiveIncomingChallenges = (state: RootState) => state.connectFive.incomingChallenges;
export const getConnectFiveMatchesById = (state: RootState) => state.connectFive.matchesById;
export const getConnectFiveOutgoingChallenges = (state: RootState) => state.connectFive.outgoingChallenges;
export const getCurrencies = (state: RootState) => state.currencies.byId;
export const getExchangeOrders = (state: RootState) => state.exchangeOrders.exchangeOrders;
export const getFollowers = (state: RootState) => state.followers;
export const getFollowings = (state: RootState) => state.followings;
export const getFrontendDeployments = (state: RootState) => state.frontendDeployments;
export const getInvitationLimits = (state: RootState) => state.invitationLimits;
export const getInvitations = (state: RootState) => state.invitations;
export const getManager = (state: RootState) => state.manager;
export const getMints = (state: RootState) => state.mints;
export const getNotifications = (state: RootState) => state.notifications.notifications || {};
export const getOrderBookBuyOrders = (state: RootState) => state.orderBook.buyOrders;
export const getOrderBookSellOrders = (state: RootState) => state.orderBook.sellOrders;
export const getPosts = (state: RootState) => state.posts.posts;
export const getSelf = (state: RootState) => state.self;
export const getTotalUnreadNotificationCount = (state: RootState) => state.notifications.totalUnreadCount;
export const getTradePriceChartData = (state: RootState) => state.tradePriceChartData;
export const getTrades = (state: RootState) => state.trades;
export const getUserStats = (state: RootState) => state.userStats;
export const getUsers = (state: RootState) => state.users;
export const getWallets = (state: RootState) => state.wallets.wallets;
export const getWires = (state: RootState) => state.wires;
export const hasMoreExchangeOrders = (state: RootState) => state.exchangeOrders.hasMore;
export const hasMoreNotifications = (state: RootState) => state.notifications.hasMore;
export const hasMorePosts = (state: RootState) => state.posts.hasMore;
export const isLoadingExchangeOrders = (state: RootState) => state.exchangeOrders.isLoading;
export const isLoadingNotifications = (state: RootState) => state.notifications.isLoading;
export const isLoadingOrderBook = (state: RootState) => state.orderBook.isLoading;
export const isLoadingPosts = (state: RootState) => state.posts.isLoading;
export const isLoadingWallets = (state: RootState) => state.wallets.pagination.isLoading;
